const emojiSizeClasses = {
  sm: 'h-6 w-6 text-[12px]',
  md: 'h-8 w-8 text-[18px]',
  lg: 'h-10 w-10 text-[24px]',
  xl: 'h-12 w-12 text-[32px]',
} as const;

const backgroundColours = {
  white: 'bg-mono-white',
  purple: 'bg-purple-200',
} as const;

export const EmojiIcon = ({
  emoji,
  size = 'xl',
  colour = 'white',
}: {
  emoji: JSX.Element;
  size?: keyof typeof emojiSizeClasses;
  colour?: keyof typeof backgroundColours;
}): JSX.Element => (
  <div
    className={`flex flex-none items-center justify-center overflow-hidden rounded-xl pt-1 align-middle ${emojiSizeClasses[size]} ${backgroundColours[colour]}`}
  >
    {emoji}
  </div>
);
